import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as _ from 'lodash';

import ChangeOwnerPopUp from '../../../components/ChangeOwner';
import ChangeAssigneeComponent from '../../../components/ChangeAssignee';
import {getActivityOwners, getWorkkardOwners,
    changeWorkkardOwner,
    changeActivityOwner,
    resetChangeWorkkardOwnerState,
    resetChangeActivityOwnerState
} from '../../../components/ChangeOwner/actions';
import { showDialogueBox } from '../../../components/DialogueBox/actions';
import { getWorkkardDetailMasterData, getActivityDetail } from "../../../containers/WorkkardDetail/actions/action";
import { ChangeOwnerType, RightPanelConstant } from '../../../containers/WorkkardDetail/constants';
import { resetChangeActivityAssigneeState} from '../../SpockViewPage/actions/action';
import { TOOLTIP_DELAY_TIME } from '../../SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../../../components/Tooltip/constants';
import UserMiniProfile from '../../../components/UserMiniProfile';

import UserImage from '../../../components/UserImage/index';

function ChangeOwnerBlock(props) {
    const dispatch = useDispatch();
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const workkardOwnerObj = useSelector(state => state.changeWorkkardOwner);
    const activityOwnerObj = useSelector(state => state.changeActivityOwner);
    const toggleView = useSelector(state => state.workkardDetail.panelVisibility.toggleView);
    const userList = useSelector(state => state.userList);
    const orgList = useSelector(state => state.orgList);

    const [expandActivityOwner, setExpandActivityOwner] = useState(false);
    const [expandWorkkardOwner, setExpandWorkkardOwner] = useState(false);
    const [changeWorkkardError, setChangeWorkkardError] = useState('');
    const [changeActivityError, setChangeActivityError] = useState('');
    const [styleWorkkardPopUp, setStyleWorkkardPopUp] = useState({});
    const [styleActivityPopUp, setStyleActivityPopUp] = useState({});
    const [isPopupExpanded, setIsPopupExpanded] = useState(false);
    const [changeSuccess, setChangeSuccess] = useState(false);
    const [changeError, setChangeError] = useState(false);
    const [workkardCurrentUserClass, setWorkkardCurrentUserClass] = useState('');
    const [activityCurrentUserClass, setActivityCurrentUserClass] = useState('');
    const [assigneeCurrentUserClass, setAssigneeCurrentUserClass] = useState('');

    const timeOut = useRef(null);
    const isPopupExpandedRef = useRef(false);
    const changeErrorRef = useRef(false);
    const expandWorkkardOwnerRef = useRef(false);
    const expandActivityOwnerRef = useRef(false);

    useEffect(() => {
        isPopupExpandedRef.current = isPopupExpanded;
    }, [isPopupExpanded]);

    useEffect(() => {
        changeErrorRef.current = changeError;
    }, [changeError]);

    useEffect(() => {
        expandWorkkardOwnerRef.current = expandWorkkardOwner;
    }, [expandWorkkardOwner]);

    useEffect(() => {
        expandActivityOwnerRef.current = expandActivityOwner;
    }, [expandActivityOwner]);

    useEffect(() => {
        window.addEventListener('resize', onWindowResize);
        return () => window.removeEventListener('resize', onWindowResize);
    }, []);

    const prevWorkkardOwnerObjRef = useRef(workkardOwnerObj);
    const prevActivityOwnerObjRef = useRef(activityOwnerObj);
    useEffect(() => {
        const prev = prevWorkkardOwnerObjRef.current;
        if (workkardOwnerObj && workkardOwnerObj.errorMessage !== prev.errorMessage) {
            setChangeWorkkardError(workkardOwnerObj.errorMessage);
        }
        prevWorkkardOwnerObjRef.current = workkardOwnerObj;
    }, [workkardOwnerObj]);

    useEffect(() => {
        const prev = prevActivityOwnerObjRef.current;
        if (activityOwnerObj && activityOwnerObj.errorMessage !== prev.errorMessage) {
            setChangeActivityError(activityOwnerObj.errorMessage);
        }
        if (activityOwnerObj && activityOwnerObj.status) {
            if (activityOwnerObj.status == 200) {
                const activityId = activityDetail.activityId;
                const values = {
                    actId: activityId,
                    callback: activityDataSuccess
                };
                dispatch(getActivityDetail(values));
                setExpandActivityOwner(false);
                setChangeSuccess(false);
                setChangeError(false);
                dispatch(resetChangeActivityOwnerState());
            }
        }
        prevActivityOwnerObjRef.current = activityOwnerObj;
    }, [activityOwnerObj]);

    useEffect(() => {
        if (workkardOwnerObj && (workkardOwnerObj.status || workkardOwnerObj.transferStatus)) {
            const isWorkloadTransfered = workkardOwnerObj.transferStatus;
            if (workkardOwnerObj.status == 200 || isWorkloadTransfered) {
                const w_id = workkard.Id;
                dispatch(getWorkkardDetailMasterData({
                    cId: w_id,
                    doNotUpdateActivityListing: true,
                    doNotUpdateSessionContext: true,
                    callback: isWorkloadTransfered ? workloadTransferSuccess : masterDataSuccess
                }));
                setExpandWorkkardOwner(false);
                setChangeSuccess(false);
                setChangeError(false);
                dispatch(resetChangeWorkkardOwnerState());
            }
        }
    }, [workkardOwnerObj]);

    useEffect(() => {
        if (isPopupExpandedRef.current) {
            if (props.layoutData) {
                calculatePopUpMarginTop();
            }
        } else if (!changeErrorRef.current) {
            setStyleWorkkardPopUp({});
            setStyleActivityPopUp({});
        }
    }, [props.layoutData]);

    function workloadTransferSuccess() {
        setWorkkardCurrentUserClass('animated fast flipInX');
        setActivityCurrentUserClass('animated fast flipInX');
        setAssigneeCurrentUserClass('animated fast flipInX');
    }

    function masterDataSuccess() {
        setWorkkardCurrentUserClass('animated fast flipInX');
        setActivityCurrentUserClass('');
        setAssigneeCurrentUserClass('');
    }

    function activityDataSuccess() {
        setWorkkardCurrentUserClass('');
        setActivityCurrentUserClass('animated fast flipInX');
        setAssigneeCurrentUserClass('');
    }

    function calculatePopUpMarginTop() {
        if (document.getElementById(`${workkard.Id}`) && expandWorkkardOwnerRef.current) {
            const popUp = document.getElementById(workkard.Id).getBoundingClientRect();
            const thirdLayout = props.layoutData;
            const heightAbovePopUp = popUp.top - thirdLayout.top;

            const totalHeightWithPopUp = heightAbovePopUp + 399;
            const totalLayoutHeight = thirdLayout.height;

            if (Math.round(totalHeightWithPopUp) > Math.round(totalLayoutHeight)) {
                setStyleWorkkardPopUp({ marginTop: props.isMobile ? -399 : (totalLayoutHeight - totalHeightWithPopUp) + 'px' });
            }
        } else if (document.getElementById(`${activityDetail.activityId}`) && expandActivityOwnerRef.current) {
            const popUp = document.getElementById(activityDetail.activityId).getBoundingClientRect();
            const thirdLayout = props.layoutData;
            const heightAbovePopUp = popUp.top - thirdLayout.top;

            const totalHeightWithPopUp = heightAbovePopUp + 399;
            const totalLayoutHeight = thirdLayout.height;

            if (Math.round(totalHeightWithPopUp) > Math.round(totalLayoutHeight)) {
                setStyleActivityPopUp({ marginTop: props.isMobile ? -450 : (totalLayoutHeight - totalHeightWithPopUp) + 'px' });
            }
        }
    }

    function onWindowResize() {
        calculatePopUpMarginTop();
    }

    // function called when close change workkard Owner popup. Called by prop callback function
    function closeWorkkardPopUp() {
        setExpandWorkkardOwner(false);
        setChangeWorkkardError('');
        setStyleWorkkardPopUp({});
        setIsPopupExpanded(false);
        setChangeSuccess(false);
        setChangeError(false);
        setWorkkardCurrentUserClass('');
        setActivityCurrentUserClass('');
        setAssigneeCurrentUserClass('');
        dispatch(resetChangeWorkkardOwnerState());
    }

    // function called when close change activity Owner popup. Called by prop callback function
    function closeActivityPopUp() {
        setExpandActivityOwner(false);
        setChangeActivityError('');
        setStyleActivityPopUp({});
        setIsPopupExpanded(false);
        setChangeSuccess(false);
        setChangeError(false);
        setActivityCurrentUserClass('');
        setWorkkardCurrentUserClass('');
        setAssigneeCurrentUserClass('');
        dispatch(resetChangeActivityOwnerState());
    }


    function changeActivityOwnerFn(obj) {
        setIsPopupExpanded(false);
        setActivityCurrentUserClass('');
        setWorkkardCurrentUserClass('');
        setAssigneeCurrentUserClass('');        
        const activityId = activityDetail.activityId;
        var finalReqPayload = {};
        finalReqPayload = {
            'WorkkardIdW': "",
            'workkard_id': activityDetail?.workkardId,
            'activity_id': activityId,
            'diary_id': "",
            'type': ChangeOwnerType.single,
            'sponser_id': obj.selectedUser.UserId,
            '__RequestVerificationToken': '',
            "isBulkNotificationOff": "",
            onSuccess: onSuccess,
            onError: onError
        };
        dispatch(changeActivityOwner(finalReqPayload));
    }


    function changeWorkkardOwnerFn(obj) {
        const w_id = workkard.Id;
        let finalReqPayload = {
            'WorkkardIdW': "",
            'WorkkardId': w_id,
            'ActivityId': "",
            'diaryId': "",
            'isBulkNotificationOff': "",
            'type': ChangeOwnerType.single,
            'SponsorId': obj.selectedUser.UserId,
            '__RequestVerificationToken': '',
            onSuccess: onSuccess,
            onError: onError,
            callback: changeWorkkardOwnerCallback
        };
        dispatch(changeWorkkardOwner(finalReqPayload));
    }

    function changeWorkkardOwnerCallback() {
        setIsPopupExpanded(false);
        setWorkkardCurrentUserClass('');
        setActivityCurrentUserClass('');
        setAssigneeCurrentUserClass('');
    }

    function onSuccess() {
        setChangeSuccess(true);
    }

    function onError() {
        setChangeError(true);
    }

    // update  redux  state and close dialog box
    function closeDialogBox() {
        dispatch(resetChangeActivityAssigneeState());
        dispatch(showDialogueBox({
            flag: false,
            dialogueBoxComponent: null,
        }));
    }

    // show  change  assignee dialog pop  up
    function changeAssigne() {
        dispatch(showDialogueBox({
            flag: true,
            component: <ChangeAssigneeComponent actId={activityDetail.activityId} wkId={workkard.Id} onClose={closeDialogBox} />,
            overlayClassName: "modal",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        }));
    }


    function openMiniProfile(targetRect, id) {
        const propertylocation = workkard.CustomFields && workkard.CustomFields.filter(x=>x.FieldKey == "propertylocation_state_state").length > 0 && workkard.CustomFields.filter(x=>x.FieldKey == "propertylocation_state_state")[0].Value;
        if (id) {
            
            dispatch({
                type: SHOW_TOOLTIP,
                payload: {
                    delay: TOOLTIP_DELAY_TIME,
                    target: targetRect,
                    childComponent: <UserMiniProfile userId={id}  wklocation={propertylocation}/>,
                }
            });
        }
    }

    /** fetch  workkard sponsors list  */
    function fetchWorkkardSponsors() {
        setExpandWorkkardOwner(true);
        setIsPopupExpanded(true);
        dispatch(getWorkkardOwners({ w_id: workkard.Id }));
    }

    /** fetch  activity sponsors list  */
    function fetchActivitySponsors() {
        setExpandActivityOwner(true);
        setIsPopupExpanded(true);
        dispatch(getActivityOwners(activityDetail.activityId));
    }

    function onMouseEnter(e, activityAssigneeId) {
        const targetRect = e.currentTarget.getBoundingClientRect();
        timeOut.current = setTimeout(() => openMiniProfile(targetRect, activityAssigneeId), 500);
    }

    function onMouseLeave() {
        clearTimeout(timeOut.current);
    }

    function getUserDisplayName(userId) {
        if (!userId || !userList || !userList[userId]) {
            return null;
        }
        const user = userList[userId];
        const firstName = user.firstName || user.first_name || '';
        const lastName = user.lastName || user.last_name || '';
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || null;
    }
    function resolveDisplayName(backendName, userId) {
        if (backendName && typeof backendName === 'string' && backendName.trim()) {
            return backendName.trim();
        }
        return getUserDisplayName(userId) || 'NA';
    }
    function getOrgDisplayName(orgId) {
        if (!orgId || !orgList || !orgList[orgId]) {
            return null;
        }
        const org = orgList[orgId];
        return org.name || org.OrganizationName || org.organization_name || null;
    }
    function resolveOrgDisplayName(backendName, orgId) {
        if (backendName && typeof backendName === 'string' && backendName.trim()) {
            return backendName.trim();
        }
        return getOrgDisplayName(orgId) || 'NA';
    }

    // Helper to validate profile image URL - returns null if invalid/broken
    function getValidProfileImage(url) {
        if (!url || typeof url !== 'string') return null;
        const trimmed = url.trim();
        if (!trimmed) return null;
        // Must be an absolute URL or path starting with / or http(s)
        if (!/^(https?:\/\/|\/)/.test(trimmed)) return null;
        return trimmed;
    }

    const workkardCurrentOwner = {
        id: workkard.Sponsor || 0,
        name: resolveDisplayName(workkard.SponsorName, workkard.Sponsor),
        profileImage: getValidProfileImage(workkard.SponsorImage),
        userClass: workkardCurrentUserClass
    };

    const activityCurrentOwner = {
        id: activityDetail.activityOwnerId || 0,
        name: resolveDisplayName(activityDetail.activityOwnerName, activityDetail.activityOwnerId),
        profileImage: getValidProfileImage(activityDetail.activityOwnerImageUrl),
        userClass: activityCurrentUserClass
    };

    const activityCurrentAssignee = {
        id: activityDetail.activityAssigneeId || 0,
        name: resolveDisplayName(activityDetail.activityAssigneeName, activityDetail.activityAssigneeId),
        profileImage: getValidProfileImage(activityDetail.activityAssigneeImageUrl)
    };

    const activityCurrentAssigneeOrg = {
        name: resolveOrgDisplayName(activityDetail.assigneeOrgName, activityDetail.assigneeOrgId),
        profileImage: getValidProfileImage(
            (orgList && orgList[activityDetail.assigneeOrgId] && orgList[activityDetail.assigneeOrgId].profile_image)
            || activityDetail.assigneeOrgImage
        ),
    };

    return (
            <React.Fragment>
                <ChangeOwnerPopUp
                    expand={expandWorkkardOwner || false}
                    changeOwner={changeWorkkardOwnerFn}
                    closePopUp={closeWorkkardPopUp}
                    type="changeWorkKardOwner"
                    id={workkard.Id}
                    currentOwner={workkardCurrentOwner}
                    errorMessage={changeWorkkardError || ''}
                    canChange={props.canChangeWorkkardOwner}
                    onCLickChangeButton={fetchWorkkardSponsors}
                    sponsors={workkardOwnerObj.sponsors || []}
                    style={styleWorkkardPopUp}
                    changeSuccess={changeSuccess}
                    changeError={changeError}
                    openMiniProfile={(targetRect,ownerId)=>openMiniProfile(targetRect,ownerId)}
                    isMob={props.isMobile}
                />
                {
                    activityDetail && activityDetail.activityId && (toggleView != RightPanelConstant.CombinedViewText) &&
                    <React.Fragment>
                        <ChangeOwnerPopUp
                            expand={expandActivityOwner || false}
                            canChange={props.canChangeActivityOwner}
                            changeOwner={changeActivityOwnerFn}
                            closePopUp={closeActivityPopUp}
                            currentOwner={activityCurrentOwner}
                            errorMessage={changeActivityError || ''}
                            type="changeActivityOwner"
                            id={activityDetail.activityId}
                            onCLickChangeButton={fetchActivitySponsors}
                            sponsors={activityOwnerObj.sponsors || []}
                            style={styleActivityPopUp}
                            changeSuccess={changeSuccess}
                            changeError={changeError}
                            openMiniProfile={(targetRect,ownerId)=>openMiniProfile(targetRect,ownerId)}
                            isMobile={props.isMobile}
                        />

                        <div className="rowFlex ">
                            <div className="userGroup">
                                <div className="dropDown onClick alignMiddle flexGrow">
                                    <div className={`rowFlex ${assigneeCurrentUserClass}`}>
                                        {activityDetail.activityAssigneeId !== 0 ?
                                            <React.Fragment>
                                                <div className="userPic userPicIcon" onMouseLeave={onMouseLeave} onMouseEnter={(e)=>onMouseEnter(e,activityDetail.activityAssigneeId)}>
                                                   <UserImage profileUrl={activityCurrentAssignee.profileImage} profileName={activityCurrentAssignee.name} />
                                
                                                </div>
                                                <div className="userInfo colFlex flexWrap"><span className="name">{activityCurrentAssignee.name}{activityDetail.isAssigneeBlocked && ( <span className="gray"> (Inactive)</span> )}</span><label>{RightPanelConstant.ActivityAssigneeText}</label></div>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <div className="userPic userPicIcon">
                                                    <UserImage profileUrl={activityCurrentAssigneeOrg.profileImage} profileName={activityCurrentAssigneeOrg.name} />
                                                </div>
                                                <div className="userInfo colFlex flexWrap"><span className="name">{activityCurrentAssigneeOrg.name}</span><label>{RightPanelConstant.ActivityAssigneeText}</label></div>
                                            </React.Fragment>
                                        }
                                    </div>
                                    {props.canChangeActivityAssignee &&
                                        <span className="change"><a className="" href="javascript:void(0)" onClick={changeAssigne}>{RightPanelConstant.ChangeText} </a></span>
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                }
                {/* <ChangeOwnerPopUp changeOwner={changeActivityOwnerFn} type="changeWorkKardOwner" id={activityDetail.ActivityId} /> */}
            </React.Fragment>
        );
}

export default ChangeOwnerBlock;